import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_GET_RESPONSE } from '@config/constanta';
import fetcher from '@helpers/fetcher';
import { V3 } from 'Util/fetcher';

function getUrl() {
  return `${V3}mutualfund/auto-order`;
}

/**
 * Docs?:
 * https://ajaib.readme.io/reference/getallautoorderusingget

*/
function callbackFetch(url, size) {
  return async ({ pageParam = 0 }) => {
    try {
      /**
       * @type {OrderListFilterResponse}
       */
      const res = await fetcher.get(url, {
        params: {
          page: pageParam,
          page_size: size,
        },
      });

      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

export const getMfAutoOrder = ({ pageSize = 20 } = {}) => {
  const url = getUrl();
  const cb = callbackFetch(url, pageSize);
  const key = [url, pageSize];
  return { cb, key };
};

export const deleteMfAutoOrder = (id) => {
  const resourceUrl = `${V3}mutualfund/auto-order/${id}/`;
  return fetcher
    .del(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};
